var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewRiArticle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 170 171",
    style: {
      enableBackground: "new 0 0 170 171"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M89.07,47c9.35,0,15.02,5.54,15.02,14.69c0,6.88-3.2,11.62-8.81,13.49c0.8,0.67,1.54,1.6,2.14,2.87l7.34,14.09 c0.8,1.54,0.4,2.27-1.14,2.27h-3.87c-2.94,0-3.74-0.33-4.54-2L89.6,81.05c-1.8-3.74-3.4-4.68-7.94-4.68h-4.94v15.76 c0,1.67-0.6,2.27-2.27,2.27h-3.81c-1.67,0-2.34-0.6-2.34-2.27V49.27c0-1.67,0.67-2.27,2.34-2.27H89.07z M95.28,61.69 c0-2.2-0.6-3.94-1.8-5.14c-1.2-1.13-2.94-1.74-5.2-1.74H76.72v13.75h11.55c2.2,0,3.94-0.6,5.2-1.8 C94.67,65.63,95.28,63.89,95.28,61.69z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.79,49.27c0-1.67,0.67-2.27,2.34-2.27h3.81c1.67,0,2.27,0.6,2.27,2.27v42.86c0,1.67-0.6,2.27-2.27,2.27h-3.81 c-1.67,0-2.34-0.6-2.34-2.27V49.27z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M152.6,4H39.7c-8.51,0-15.4,6.89-15.4,15.39v10.27h-5.13c-8.51,0-15.39,6.89-15.39,15.39v102.64 c0,11.34,9.19,20.53,20.53,20.53h123.17c11.34,0,20.53-9.19,20.53-20.53V19.39C168,10.89,161.11,4,152.6,4 M157.73,147.69 c0,5.65-4.6,10.27-10.27,10.27H24.3c-5.66,0-10.26-4.61-10.26-10.27V45.05c0-2.83,2.3-5.13,5.13-5.13h5.13v102.64 c0,2.84,2.3,5.13,5.13,5.13c2.84,0,5.13-2.3,5.13-5.13V19.39c0-2.83,2.3-5.13,5.13-5.13h112.9c2.83,0,5.13,2.3,5.13,5.13V147.69z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M88.45,142.58H47.4c-1.42,0-2.57,1.15-2.57,2.56c0,1.43,1.15,2.57,2.57,2.57h41.05c1.42,0,2.57-1.14,2.57-2.57 C91.02,143.73,89.87,142.58,88.45,142.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M144.9,142.58h-41.05c-1.42,0-2.57,1.15-2.57,2.56c0,1.43,1.15,2.57,2.57,2.57h41.05 c1.41,0,2.56-1.14,2.56-2.57C147.47,143.73,146.32,142.58,144.9,142.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M144.9,123.91H47.4c-1.42,0-2.57,1.15-2.57,2.56c0,1.43,1.15,2.57,2.57,2.57h97.51c1.41,0,2.56-1.14,2.56-2.57 C147.47,125.06,146.32,123.91,144.9,123.91"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewRiArticle);
export default __webpack_public_path__ + "static/media/newRiArticle.1389395a0697b2ed4437951e392799f3.svg";
export { ForwardRef as ReactComponent };